import React from 'react'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {BottomCTA} from 'components/Accommodation/Offers/BottomCTA'
import {PolicySubSection} from 'components/Accommodation/Policies/types'
import {getHotelPoliciesOverlay} from 'modules/overlay/selectors'
import {hideOverlay} from 'modules/overlay/slice'

import {BottomSheet} from '@daedalus/atlas/BottomSheet'
import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {Stack} from '@daedalus/atlas/helpers/Stack'
import {PopUp} from '@daedalus/atlas/PopUp'
import {useGetHotelQuery} from '@daedalus/core/src/sapi/services/searchApi'

import {HotelContent} from './HotelContent'
import {getAvailableContentKeys, getTitle} from './utils'

interface Props {
  hotelId: string | undefined
}

export const PoliciesDetailsOverlay: React.FC<Props> = ({hotelId}) => {
  const dispatch = useDispatch()
  const {formatMessage} = useIntl()
  const {isMobile} = useDeviceLayout()

  const onClose = () => dispatch(hideOverlay())

  const {data: contentHotel} = useGetHotelQuery(
    {
      hotelId
    },
    {
      skip: !hotelId
    }
  )

  const activeSection = useSelector(getHotelPoliciesOverlay)?.policySubSection
  const isGoodToKnow = activeSection === PolicySubSection.GoodToKnow
  if (!contentHotel) return null

  const contentKeys = activeSection
    ? getAvailableContentKeys(contentHotel, activeSection)
    : []

  const content = (
    <Stack space="s800">
      {contentKeys.map(key => (
        <HotelContent key={key} hotel={contentHotel} contentKey={key} />
      ))}
    </Stack>
  )

  return isMobile ? (
    <BottomSheet
      titleBarProps={{
        centerContent: activeSection && formatMessage(getTitle(activeSection))
      }}
      footerContent={
        <BottomCTA
          hotelId={hotelId}
          sourceComponent="MobileHotelViewAllPoliciesStaticOfferCTA"
        />
      }
      withDragHandler={isGoodToKnow}
      snapPoints={isGoodToKnow ? {top: 'nearFull', middle: 0.7} : undefined}
      isOpen={Boolean(activeSection)}
      onClose={onClose}
      prefersReducedMotion
    >
      {content}
    </BottomSheet>
  ) : (
    <PopUp
      titleBarProps={{
        centerContent: activeSection && formatMessage(getTitle(activeSection))
      }}
      isOpen={Boolean(activeSection)}
      closeAction={onClose}
      width={640}
    >
      {content}
    </PopUp>
  )
}
